import { render, staticRenderFns } from "./changeInformation-edit.vue?vue&type=template&id=2c1e2474&scoped=true"
import script from "./changeInformation-edit.vue?vue&type=script&lang=js"
export * from "./changeInformation-edit.vue?vue&type=script&lang=js"
import style0 from "./changeInformation-edit.vue?vue&type=style&index=0&id=2c1e2474&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1e2474",
  null
  
)

export default component.exports